import { render } from "./ForgotPasswordBody2.vue?vue&type=template&id=58d02e60"
import script from "./ForgotPasswordBody2.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordBody2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__